import {z} from 'zod';
/** Bounded HTTP entity-tag list. Weak comparison is appropriate for GET representations. */
function tags(input:string):string[]|null{
 if(/[^\x20-\x7e\t]/.test(input))return null;const value=input.trim();if(value==='*')return ['*'];if(!value||value.length>1024)return null;
 const result:string[]=[],pattern=/(?:W\/)?"([\x21\x23-\x7e]{0,128})"/y;let at=0;
 while(at<value.length){pattern.lastIndex=at;const match=pattern.exec(value);if(!match)return null;result.push(match[1]!);if(result.length>8)return null;at=pattern.lastIndex;
  while(value[at]===' '||value[at]==='\t')at++;if(at===value.length)return result;if(value[at]!==',')return null;at++;while(value[at]===' '||value[at]==='\t')at++;if(at===value.length)return null;
 }return null;
}
export const SurfaceIfNoneMatch=z.string().max(1024).refine(value=>tags(value)!==null,'INVALID_SURFACE_CONDITIONAL_HEADER');
export const SurfaceEntityTag=z.string().regex(/^W\/"saa-surface-[a-f0-9]{64}"$/);
export function surfaceNotModified(header:string|undefined,etag:string):boolean{
 const current=SurfaceEntityTag.parse(etag).slice(3,-1);if(header===undefined)return false;const parsed=tags(SurfaceIfNoneMatch.parse(header))!;return parsed.includes('*')||parsed.includes(current);
}
